var _path, _path2, _path3, _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7128 40.1924C31.7585 40.1924 40.7128 31.2381 40.7128 20.1924C40.7128 9.14669 31.7585 0.192383 20.7128 0.192383C9.66707 0.192383 0.712769 9.14669 0.712769 20.1924C0.712769 31.2381 9.66707 40.1924 20.7128 40.1924Z",
    fill: "#97144D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0461 12.7447V30.8591C22.0461 31.5954 21.4491 32.1924 20.7127 32.1924C19.9763 32.1924 19.3794 31.5954 19.3794 30.8591V12.7447L13.6555 18.4685C13.1348 18.9892 12.2906 18.9892 11.7699 18.4685C11.2492 17.9478 11.2492 17.1036 11.7699 16.5829L19.7691 8.58368C19.7723 8.58052 19.7755 8.57737 19.7787 8.57424C19.9045 8.45071 20.0487 8.35714 20.2023 8.29355C20.3596 8.22836 20.5319 8.19238 20.7127 8.19238C21.0765 8.19238 21.4062 8.33805 21.6468 8.57424C21.65 8.5774 21.6532 8.58057 21.6564 8.58376L29.6555 16.5829C30.1762 17.1036 30.1762 17.9478 29.6555 18.4685C29.1348 18.9892 28.2906 18.9892 27.7699 18.4685L22.0461 12.7447Z",
    fill: "#171A21"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3238_20767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 8,
    width: 20,
    height: 25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0461 12.7447V30.8591C22.0461 31.5954 21.4491 32.1924 20.7127 32.1924C19.9763 32.1924 19.3794 31.5954 19.3794 30.8591V12.7447L13.6555 18.4685C13.1348 18.9892 12.2906 18.9892 11.7699 18.4685C11.2492 17.9478 11.2492 17.1036 11.7699 16.5829L19.7691 8.58368C19.7723 8.58052 19.7755 8.57737 19.7787 8.57424C19.9045 8.45071 20.0487 8.35714 20.2023 8.29355C20.3596 8.22836 20.5319 8.19238 20.7127 8.19238C21.0765 8.19238 21.4062 8.33805 21.6468 8.57424C21.65 8.5774 21.6532 8.58057 21.6564 8.58376L29.6555 16.5829C30.1762 17.1036 30.1762 17.9478 29.6555 18.4685C29.1348 18.9892 28.2906 18.9892 27.7699 18.4685L22.0461 12.7447Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3238_20767)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(4.71277 4.19238)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.71277,
    y: 4.19238,
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3238_20767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 33,
    height: 33
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.71277,
    y: 4.19238,
    width: 32,
    height: 32,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3238_20767)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.71277,
    y: 4.19238,
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.f5d68260a18b0aeff6108928ac0dc4f8.svg";
export { ForwardRef as ReactComponent };